import { Button } from '@snapi/luxury';
import { useReportContext } from '../report-context';
import RedCircle from './images/red-circle.png';
import YellowSnape from './images/yellow-shape.png';
import YellowEgg from './images/yellow-egg.png';
import YellowCircle from './images/yellow-circle.png';
import OrangeCircle from './images/orangecircle.png';
import Image from 'next/image';

export const ReportFeedbackSection = () => {
  const { test, baby, parent } = useReportContext();

  const handleScheduleCall = () => {
    window.open(
      `https://calendly.com/danasnapi/snapi-health-microbiome-test-result-questions`
    );
  };

  const handleAskQuestion = () => {
    window.open(
      `mailto:dana@snapihealth.com?subject=Question from ${parent.name} about ${test.id} for ${baby.name}&cc=info@snapihealth.com`
    );
  };

  return (
    <div id="feedback-section" className="bg-blue mt-[50px] md:mt-[150px]">
      <div className="flex justify-center ">
        <div className="flex flex-col items-center bg-blue py-10 px-3 sm:px-11 sm:py-14 rounded-2xl w-full overflow-hidden relative">
          <div className="absolute w-[76px] top-[-20px] right-[-30px] xs:top-[46px] xs:right-[-40px] sm:w-[106px] sm:top-0 sm:right-0 md:top-0 md:right-0 lg:w-[146px] lg:right-[40px] xl:w-[196px] xl:right-[80px]">
            <Image {...RedCircle} alt="" />
          </div>
          <div className="absolute w-[104px] mx-auto top-[-50px] sm:w-[184px] sm:mx-0 sm:left-[-46px] sm:top-[-80px] md:left-0 md:top-[-70px] lg:w-[144px] lg:top-[20px] xl:w-[186px] lg:left-[86px] xl:left-[150px]">
            <Image {...OrangeCircle} alt="" />
          </div>
          <div className="absolute w-[94px] left-[-66px] top-[30px] sm:w-[124px] sm:left-[-80px] md:left-[-50px] lg:left-[-40px] lg:top-[40px] xl:top-[60px] xl:left-0">
            <Image {...YellowCircle} alt="" />
          </div>
          <div className="px-3">
            <h2 className="text-blue-dark text-center max-w-[400px] mx-auto">
              Support and education, from start to finish
            </h2>
            <p className="mt-4 text-blue-dark text-center max-w-[556px]">
              Parenting comes with many questions and lots of learning. Schedule{' '}
              <span className="font-semibold">a free 15 minutes call</span> with
              one of our{' '}
              <span className="font-semibold">microbiome experts</span> to
              review results or receive answers to questions.
            </p>
            <div className="mt-7 gap-3 lg:mt-10 flex flex-1 flex-col justify-center items-center sm:flex-row z-10">
              <span>
                <Button size="md" onClick={handleScheduleCall}>
                  Schedule a call
                </Button>
              </span>
              <span>
                <Button size="md" secondary onClick={handleAskQuestion}>
                  Email us
                </Button>
              </span>
            </div>
          </div>

          <div className="absolute bottom-[-40px] left-[20px] w-[120px] sm:w-[150px] md:w-[180px] md:bottom-[-50px] lg:w-[230px] lg:bottom-[-30px] lg:left-[60px] xl:bottom-[-8px] xl:left-[110px]">
            <Image {...YellowSnape} alt="" />
          </div>
          <div className="absolute bottom-[-8px] right-[-60px] w-[122px] sm:w-[182px] sm:right-[-90px] md:right-[-60px] lg:w-[232px] lg:right-[-50px] xl:w-[252px] xl:right-[50px]">
            <Image {...YellowEgg} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};
